// dev 配置接口
export default {
  api: 'https://interface.54traveler.com',
  apiM: 'https://we-interface.54traveler.com',
  apiWe: 'https://we-interface.54traveler.com',
  siteUrl: 'https://we.54traveler.com'
}



/** WEBPACK FOOTER **
 ** ./src/libs/dev.js
 **/